import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import { AuthContext } from "../../context/AuthContext";
import { GET_BATCH_WISE_EXP_SHIPMENT } from "../../services/apiRoutes";
import { genericGet, } from "../../services/apiServices";
import CustomReport from "../common/CustomReport";
import { useCompanyDateFormat } from "../../constants/useCompanyDateFormat";
import { getColorById, getColorPlate, getCustumersList } from "../../services/CommonServices";
import { genericPost } from "../../services/authServices";
import CustomFilter from "../common/CustomFilter";
import { Box, Grid } from "@mui/material";
import CustomTextField from "../common/CustomTextField";
import CustomAutocomplete from "../common/CustomAutoComplete";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import CustomButton from "../common/CustomButton";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";
import CustomStatus from "../common/CustomStatus";


const title = "Batch No Wise Export Shipment Report";

const BatchNoWiseExportShipmentReport = () => {
    const companyDateFormat = useCompanyDateFormat();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [permission, setPermissions] = useState()
    const [error, setError] = useState(null);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [colorlist, setColorlist] = useState([]);
    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
        customerNamesId: '',
        fromDate: '',
        toDate: '',

    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                shipmentId: '',
                customerNamesId: '',
                fromDate: '',
                toDate: '',
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);
    useEffect(() => {
        getCommonData();
    }, []);
    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
        const colorData = await getColorPlate();
        setColorlist(colorData);
    }

    const ReadMore = ({ content, maxLength = 100 }) => {
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };
        const contentStr = typeof content === "string" ? content : String(content || "");
        const shortContent = contentStr.slice(0, maxLength);
        return (
            <div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: isReadMore ? shortContent : contentStr,
                    }}
                />
                {contentStr.length > maxLength && (
                    <span
                        onClick={toggleReadMore}
                        style={{ color: "#AEAEAE", cursor: "pointer" }}
                    >
                        {isReadMore ? "...read more" : " show less"}
                    </span>
                )}
            </div>
        );
    };

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            { accessorKey: 'createdAt', header: 'Date', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'shipmentId', header: 'Shipment I’d', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'proformaInvoiceNo', header: 'PI No.', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'BatchNo', header: 'Batch No.', size: 100, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: 'clientCompanyName', header: 'Customer Name', size: 150, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },

            {
                accessorKey: "country",
                header: "Country",
                tableStyle: { textAlign: "center" },
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <CustomStatus
                            title={row.original.country}
                            sx={{
                                backgroundColor: row.original.countryIdBackground,
                                color: row.original.countryIdColor,
                                border: `1px solid ${row.original.countryIdColor}`,
                                textAlign: "center",
                                display: "inline-block",
                            }}
                        />
                    );
                },
                enableSorting: false,
            },
            { accessorKey: 'blNo', header: 'BL No.', size: 100, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: "ShippingMark",
                header: "Shipping Mark",
                tableStyle: { textAlign: "left" },
                size: 200,
                Cell: ({ row }) => {
                    return <ReadMore content={row.original.ShippingMark || ''} maxLength={150} />;
                },
                enableSorting: false,
            },
        ],
        [permission]
    );
    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };

            // const response = await genericGet({ url: GET_BATCH_WISE_EXP_SHIPMENT });
            const response = await genericPost(GET_BATCH_WISE_EXP_SHIPMENT, payload, {});
            if (response.data.success && response.data.matchedShipments?.length) {
                const shippingMarkData = response.data.matchedShipments.map((shipment, index) => {
                    const shippingMark = shipment.shippingMark || {};
                    const proformaInvoice = shipment.proformaInvoice || {};

                    const countryColorObj = getColorById(shippingMark.clientCompany?.billingCountry?.id, colorlist, {
                        matchKey: "colorId",
                        prefixLength: 1,
                    });
                    return {
                        shippingMarkId: shippingMark.shippingMarkId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        companyId: shippingMark.companyId || '',
                        shipmentId: shippingMark.shipmentId || '',
                        blNo: shipment?.blNo || '',
                        clientCompanyName: shippingMark.clientCompany?.clientCompanyName || '',
                        country: shippingMark.clientCompany?.billingCountry?.name || '',
                        BatchNo: shippingMark.batchNo || '',
                        proformaInvoiceNo: proformaInvoice.proformaInvoiceNo || '',
                        productId: shippingMark.productsList?.productName || '',
                        ShippingMark: shippingMark.shippingMark || '',
                        createdAt: companyDateFormat(shippingMark.createdAt) || '',
                        updatedAt: shippingMark.updatedAt || '',
                        countryIdColor: countryColorObj.color || '',
                        countryIdBackground: countryColorObj.backgroundColor || '',
                    };
                });

                setData(shippingMarkData);
                setRowCount(response.data.pagination?.totalRecords || 0);
            } else {
                setError('No shipping marks found');
            }
        } catch (error) {
            setError('Error fetching shipping marks');
            console.error('Error fetching shipping marks', error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchData(page, pageSize)
    }, [token, page, pageSize, colorlist])

    const defaultView = 'batchnowiseexportshipmentreport';
    const mainContent = (
        <>
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}
            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomAutocomplete
                                        options={custumersList}
                                        getOptionLabel={(option) => option.title}
                                        placeholder="Select Customer"
                                        value={custumersList.find((item) => item.id === filterPayload.customerNamesId) || null}
                                        onChange={(event, newValue) => handleFilterChange("customerNamesId", newValue?.id)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)} />
            {!permission?.view && <AccessDenied />}

        </>
    );
};
export default BatchNoWiseExportShipmentReport;
